import {
  IParamsChoosePropertie,
  IPropertie,
  IResponseChoosePropertie,
} from 'v2/resources/types/properties';

export const DEFAULT_RESPONSE_PROPORTIES: IPropertie[] = [
  {
    id: '',
    type: '',
    start_trial: '',
    name: '',
    corporate_name: null,
    street: '',
    district: null,
    uf: '',
    latitude: null,
    longitude: null,
    owner: '',
    rented: false,
    phone: '',
    cnpj: '',
    cep: null,
    city: '',
    state: '',
    number: '',
  },
];
export const DEFAULT_RESPONSE_CHOSEN_PROPERTIE: IResponseChoosePropertie = {
  access_token: '',
  domain_permissions: [],
};
